module.exports = ".tableOverride th {\n  color: #4d4d4d;\n  font-family: myriadpro-semibold; }\n\n.tableOverride td {\n  color: #4d4d4d;\n  font-family: myriadpro; }\n\n.add-btn:hover {\n  background-color: #449d44;\n  border-color: #449d44;\n  color: white; }\n\n.remove-btn:hover {\n  background-color: #CC0000;\n  border-color: #CC0000;\n  color: #fff; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/accounts/accountdetail.component.scss
// module id = 574
// module chunks = 1